import {
  MenuList,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Collapse,
} from '@mui/material'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { ExpandLess, ExpandMore, ForumOutlined } from '@mui/icons-material'
import { MenuBanHistory } from './sub-menus/MenuBanHistory'
import { MenuBannedUsers } from './sub-menus/MenuBannedUsers'
import { MenuModeration } from './sub-menus/MenuModeration'
import { MenuPersonas } from './sub-menus/MenuPersonas'
import { MenuReports } from './sub-menus/MenuReports'
import { MenuUsageStats } from './sub-menus/MenuUsageStats'
import { MenuEventSummary } from './sub-menus/MenuEventSummary'
import { TtoggleDrawerOnMobile } from '../../../containers/Sidebar/Sidebar'
import { useStyles } from '../../../containers/Sidebar/Sidebar.styles'
import { useOAuth } from '@novafuturltd/core'
import parseOrgId from '../../../helpers/parseOrgId/parseOrgId'
import { OrgIdTypeEnum } from '../../../containers/Sidebar/trading/types'

interface LiveChatSubMenuProps {
  hoverDrawer?: boolean
  openDrawer?: boolean
  permissions: string[]
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const LiveChatSubMenu = ({
  toggleDrawerOnMobile,
  openDrawer,
  hoverDrawer,
}: LiveChatSubMenuProps) => {
  const { formatMessage } = useIntl()
  const { pathname } = useRouter()
  const classes = useStyles({ openDrawer, hoverDrawer })
  const [open, setOpen] = useState(pathname.includes('/live-chat'))
  const { organizationId: orgId } = useOAuth()

  const handleClick = () => {
    setOpen(!open)
  }

  if (parseOrgId(orgId) !== OrgIdTypeEnum.BET9JA) {
    return null
  }

  return (
    <MenuList aria-labelledby="nested-list-subheader" className={classes.root}>
      <MenuItem
        onClick={handleClick}
        className={classes.menuItem}
        selected={
          !openDrawer && !hoverDrawer && pathname.startsWith('/live-chat')
        }
      >
        <ListItemIcon>
          <ForumOutlined />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({
            id: 'liveChat.sidebar.title',
          })}
          hidden={!openDrawer && !hoverDrawer}
        />
        {open ? (
          <ExpandLess className={classes.expandIcon} />
        ) : (
          <ExpandMore className={classes.expandIcon} />
        )}
      </MenuItem>
      <Collapse
        in={open}
        timeout="auto"
        unmountOnExit
        hidden={!openDrawer && !hoverDrawer}
      >
        <MenuList component="div" disablePadding>
          <MenuPersonas
            pathname={pathname}
            toggleDrawerOnMobile={toggleDrawerOnMobile}
            nested={
              openDrawer || hoverDrawer ? classes.nested : classes.nestedClosed
            }
          />
        </MenuList>
        <MenuList component="div" disablePadding>
          <MenuBanHistory
            pathname={pathname}
            toggleDrawerOnMobile={toggleDrawerOnMobile}
            nested={
              openDrawer || hoverDrawer ? classes.nested : classes.nestedClosed
            }
          />
        </MenuList>
        <MenuList component="div" disablePadding>
          <MenuBannedUsers
            pathname={pathname}
            toggleDrawerOnMobile={toggleDrawerOnMobile}
            nested={
              openDrawer || hoverDrawer ? classes.nested : classes.nestedClosed
            }
          />
        </MenuList>
        <MenuList component="div" disablePadding>
          <MenuModeration
            pathname={pathname}
            toggleDrawerOnMobile={toggleDrawerOnMobile}
            nested={
              openDrawer || hoverDrawer ? classes.nested : classes.nestedClosed
            }
          />
        </MenuList>
        <MenuList component="div" disablePadding>
          <MenuReports
            pathname={pathname}
            toggleDrawerOnMobile={toggleDrawerOnMobile}
            nested={
              openDrawer || hoverDrawer ? classes.nested : classes.nestedClosed
            }
          />
        </MenuList>
        <MenuList component="div" disablePadding>
          <MenuUsageStats
            pathname={pathname}
            toggleDrawerOnMobile={toggleDrawerOnMobile}
            nested={
              openDrawer || hoverDrawer ? classes.nested : classes.nestedClosed
            }
          />
        </MenuList>
        <MenuList component="div" disablePadding>
          <MenuEventSummary
            pathname={pathname}
            toggleDrawerOnMobile={toggleDrawerOnMobile}
            nested={
              openDrawer || hoverDrawer ? classes.nested : classes.nestedClosed
            }
          />
        </MenuList>
      </Collapse>
    </MenuList>
  )
}
